import React from "react";
import { RotateCcw, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const RefundPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="refund-page">
      <div className="container-main max-w-4xl">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-slate-600 hover:text-sky-600 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
              <RotateCcw className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900 font-['Outfit']">Refund & Cancellation Policy</h1>
              <p className="text-slate-500">Last Updated: March 2026</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-8">
          {/* Subscription Cancellations */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">1. Subscription Cancellations</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Memberships are billed monthly. You may cancel at any time. Upon cancellation, you will continue to have access to member benefits until the end of your current billing cycle. We do not provide pro-rata refunds for partial months.
            </p>
          </section>

          {/* Convenience and Delivery Fees */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">2. Convenience and Delivery Fees</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              The convenience fee (4% or 7%) and the $10 delivery fee are non-refundable once the service has been initiated.
            </p>
          </section>

          {/* Product Refunds */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">3. Product Refunds (The "Store-Direct" Policy)</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Bundlecart acts as a facilitator. When you purchase groceries through our platform:
            </p>
            <ul className="list-disc list-inside space-y-3 text-slate-600 ml-4">
              <li>
                We can provide you with the official tax invoice/receipt from the respective retailer (e.g., Coles, Woolworths).
              </li>
              <li>
                <span className="font-medium text-slate-700">Defective or Missing Goods:</span> If a product is expired, damaged, or missing, you must seek a refund directly from the retailer using the provided receipt.
              </li>
              <li>
                <span className="font-medium text-slate-700">Bundlecart's Role:</span> Our service is complete once the goods are delivered and the receipt is provided.
              </li>
            </ul>
          </section>

          {/* Australian Consumer Law */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">4. Australian Consumer Law (ACL)</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Nothing in this policy excludes, restricts, or modifies any guarantees or rights you have under the Australian Consumer Law. If there is a major failure with the Bundlecart service itself (e.g., technical payment error), we will provide a remedy in accordance with your statutory rights.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-slate-50 rounded-xl p-6 border border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Contact Us</h3>
            <p className="text-slate-600">
              For all inquiries, please contact{" "}
              <a href="mailto:support@bundlecart.au" className="text-sky-600 hover:text-sky-700 font-medium">
                support@bundlecart.au
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPage;
